'use strict';

jQuery(function ($) {
//  	$( ".btn-photo" ).hover(()=> {
//    	$( ".bg-overlay" ).css( "z-index" , "3" );
//    	$( ".bg-overlay" ).css( "opacity" , "0.5" );
//    },()=>{
//    	$( ".bg-overlay" ).css( "z-index" , "0" );
//    	$( ".bg-overlay" ).css( "opacity" , "0" );
//    });
});
